import { motion } from "framer-motion";
import { ComponentProps, ReactNode } from "react";

type Props = ComponentProps<typeof motion.div> & {
  children: ReactNode;
  isOpen: boolean;
};

const ExpandableSection = ({ children, isOpen, ...motionProps }: Props) => (
  <motion.div
    animate={isOpen ? "open" : "closed"}
    initial="closed"
    style={{ overflow: "hidden" }}
    transition={{ duration: 0.3, ease: "easeInOut" }}
    variants={{
      closed: { height: 0, opacity: 0 },
      open: { height: "auto", opacity: 1 }
    }}
    {...motionProps}
  >
    {children}
  </motion.div>
);

export default ExpandableSection;
